import { render, staticRenderFns } from "./TemplateEdit.vue?vue&type=template&id=6af22429&"
import script from "./TemplateEdit.vue?vue&type=script&lang=js&"
export * from "./TemplateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports